import { CONTENT_GROUP_ACTION } from "../constants";

const initialState = {
    minimizedCards: []
};

export const minimized_card = (state = initialState, action) => {
    switch (action.type) {
        case CONTENT_GROUP_ACTION.MINIMIZE_CARD:
            const updatedCards = state.minimizedCards.some(card => card.id === action.payload.id)
                ? state.minimizedCards.map(card =>
                    card.id === action.payload.id ? { ...card, ...action.payload } : card
                )
                : [ ...state.minimizedCards, action.payload];

            return {
                ...state,
                minimizedCards: updatedCards
            };

        case CONTENT_GROUP_ACTION.SET_MINIMIZED_CARDS: {
            return {
                ...state,
                minimizedCards: action.payload
            };
        }
        case CONTENT_GROUP_ACTION.REMOVE_MINIMIZED_CARD:
            return {
                ...state,
                minimizedCards: state.minimizedCards.filter(card => card.id !== action.payload)
            };
        case CONTENT_GROUP_ACTION.BULK_REMOVE_MINIMIZED_CARDS:
            return {
                ...state,
                minimizedCards: state.minimizedCards.filter(card => !action.payload.includes(card.id))
            };
        case CONTENT_GROUP_ACTION.RESET_MINIMIZED_CARDS:
            return {
                ...state,
                minimizedCards: []
            };
        default:
            return state;
    }
};